import { createContext } from 'react';
import d from './dictionary.json';

export const LanguageContext = createContext({
  userLanguage: "en",
  dictionary: d
})